import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/lib/trpc";

export const useSubscription = (input: { includePaddleSubscription?: boolean } = {}) => {
    const trpc = useTRPC();
    const opts = trpc.subscription.get.queryOptions(input, {
        staleTime: 10 * 1000, // 10 seconds. We ask this thing a couple of times in a row when loading, so we cache it for a couple of seconds to avoid refetching.
        gcTime: 10 * 1000, // 10 seconds
    });
    const result = useQuery(opts);
    return {
        ...result,
        /** Whether the user has a subscription. This is true if the user has a subscription once, after a trial. Maybe it is not active anymore, but it was there once. */
        hasSubscription: !!result.data?.subscription,
    };
};

export const useInvoices = () => {
    const trpc = useTRPC();
    const opts = trpc.subscription.listInvoices.queryOptions(undefined);
    return useQuery(opts);
};
